const value = {
    name: 'Название',
    recommendedUnits: 'Рекомендованные юниты для роли',
    editingProjectFields: 'Редактирование полей проекта',
    editingProjectTeams: 'Редактирование команды проекта',
    creatingNewProfiles: 'Создание новых анкет',
    editingProfiles: 'Редактирование анкет',
    generatingReports: 'Формирование отчетов',
    creatingRequirements: 'Создание требований',
    acceptingAndDeletingRequirements: 'Принятие и исключение требований',
    receivingNotificationsOfNewComments: 'Может получать уведомления о новых комментариях',
    viewingUnverifiedRequirements: 'Просмотр неверифицированных требований',
    viewingRequirementsOfExternalRegulatoryAuthorities: 'Просмотр требований внешних регуляторов',
    integratingASWithJira: 'Возможность интегрировать АС с Jira',
    managingRequirementsVerification: 'Просмотр неверифицированных требований',
    terminatingAcceptanceTests: 'Доступ к принятию/исключению требований систем без проектных прав',
    rolesUpdatedTitle: 'Роли были обновлены',
    rolesUpdatedMessage: 'Роли были обновлены. Юниты появятся позже.',
    writeRequirementRemarks: 'Внесение замечаний к требованиям',
  };

export default value;
